
import customAxios from '../../customHook/customAxios';
import { getAuthHeader } from '../../utils';

export const v2_projects = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/projects`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}
export const v2_builders = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/builder`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v2_ships = async (shipOwnerId = null, projectId = null, yardId = null) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/ships?shipOwnerId=${shipOwnerId}&projectId=${projectId}&yardId=${yardId}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}